import { Card, emptyFragment, Typography, TypographyColor } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { currentUserStore } from '../../../../CurrentUserStore';
import { T } from '../../../../Translations';
import { useQueryWithDecoder } from '../../../../UseQueryWithDecoder';
import CardTitle from '../../Shared/CardTitle';
import { adminTasksResourceDecoder, TaskStatus } from './Decoder';
import TaskDetail from './TaskDetail';
import TaskStatusIcon from './TaskStatusIcon';
import TasksSkeleton from './TasksSkeleton';

export function statusCss(status: TaskStatus): TypographyColor {
  switch (status) {
    case 'complete':
      return 'dark';
    case 'incomplete':
      return 'dark';
  }
}

export function statusClassName(status: TaskStatus): string {
  switch (status) {
    case 'complete':
      return '!text-gray-500';
    case 'incomplete':
      return '';
  }
}

function Tasks() {
  const { data, isLoading, error } = useQueryWithDecoder(
    'tasks',
    currentUserStore.links,
    adminTasksResourceDecoder,
  );

  if (isLoading) {
    return <TasksSkeleton />;
  }

  if (error || !data) {
    console.error('Failed to load tasks:', error);
    return emptyFragment();
  }

  return (
    <div>
      <CardTitle title="Admin Tasks" />
      <Card className="w-full pt-7 pr-4 pb-4 pl-6" radius="lg">
        <Typography variant="bodyMedium" color="dark">
          <T kind="Follow the steps below to get your first collection up and running." />
        </Typography>
        <div className="pr-4">
          {data.payload.taskList.map(({ status, kind }) => (
            <div key={kind} className="flex justify-between mt-5">
              <div className="flex items-center w-full">
                <TaskStatusIcon iconStatus={status} />
                <div className="flex w-[95%] justify-between">
                  <Typography
                    variant="bodyMedium"
                    color={statusCss(status)}
                    className={`w-[90%] ml-3 capitalize ${statusClassName(status)}`}
                  >
                    <TaskDetail kind={kind} />
                  </Typography>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}

export default observer(Tasks);
